'use strict';

var Dispatcher = require('flux').Dispatcher,
    copyProperties = require('react/lib/copyProperties');

var DragDropDispatcher = copyProperties(new Dispatcher(), {
  handleAction:function(action) {
    this.dispatch({
      action: action
    });
  }
});

module.exports = DragDropDispatcher;


/*****************
 ** WEBPACK FOOTER
 ** ../modules/dispatcher/DragDropDispatcher.js
 ** module id = 77
 ** module chunks = 0
 **/